let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("35BoT")).then(() => parcelRequire('avGlQ'));